@for (item of list()?.messages; track trackByFn; let index = $index) {
  <app-notification-message
    [data]="item"
    [index]="index"
  ></app-notification-message>
}
